<template>
  <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>
  
  <div class="container">
    <div class="row">
      <div class="col-md-12 row">
        <h3 style="text-align: left;">Legal</h3> <h3><b>Tamaño máximo en archivos 5 MB</b></h3>
        <br>
        <div class="row">
          <ul class="styled-list col-md-12">
            <li class="list-item row" v-for="form in arregloLegal" :key="form.id">
              <template v-if="form.tipo == 'Legal'">
                <div class="col-md-4" style="text-align: left;">
                  <span v-if="form.estatus == 'Pendiente'" class="circle"></span>
                  <span v-else class="circlecolor"></span>
                  {{ form.nombre }}
                </div>
                <div class="col-md-8" style="text-align: left;">
                  <input type="file" class="form-control" @change="event => handleFileUpload(event, form.id)" /><br>
                  <button v-if="form.nombreArchivo" type="button" class="btn btn-warning btn-sm" @click="downloadPDF(form)"><span class="fa fa-download"></span> &nbsp; {{ form.nombreArchivo }}</button>&nbsp;
                  <button v-if="form.nombreArchivo" type="button" class="btn btn-danger btn-sm" @click="eliminarArchivo(form.id)"><span class="fa fa-trash"></span>&nbsp;Eliminar</button>
                </div>
              </template>
            </li>
          </ul>
        </div>
        <h3 style="text-align: left;">Inspector</h3>
        <div class="row">
          <ul class="styled-list col-md-12">
            <li class="list-item row" v-for="form in arregloInspector" :key="form.id">
              <template v-if="form.tipo == 'Inspector'">
                <div class="col-md-4" style="text-align: left;">
                  <span v-if="form.estatus == 'Pendiente'" class="circle"></span>
                  <span v-else class="circlecolor"></span>
                  {{ form.nombre }}
                </div>
                <div class="col-md-8" style="text-align: left;">
                  <input type="file" class="form-control" @change="event => handleFileUpload(event, form.id)" /><br>
                  <button v-if="form.nombreArchivo" type="button" class="btn btn-warning btn-sm" @click="downloadPDF(form)"><span class="fa fa-download"></span> &nbsp; {{ form.nombreArchivo }}</button>&nbsp;
                  <button v-if="form.nombreArchivo" type="button" class="btn btn-danger btn-sm" @click="eliminarArchivo(form.id)"><span class="fa fa-trash"></span>&nbsp;Eliminar</button>
                </div>
              </template>
            </li>
          </ul>
        </div>
        <h3 style="text-align: left;">CRE</h3>
        <div class="row">
          <ul class="styled-list col-md-12">
            <li class="list-item row" v-for="form in arregloCRE" :key="form.id">
              <template v-if="form.tipo == 'CRE'">
                <div class="col-md-4" style="text-align: left;">
                  <span v-if="form.estatus == 'Pendiente'" class="circle"></span>
                  <span v-else class="circlecolor"></span>
                  {{ form.nombre }}
                </div>
                <div class="col-md-8" style="text-align: left;">
                  <input type="file" class="form-control" @change="event => handleFileUpload(event, form.id)" /><br>
                  <button v-if="form.nombreArchivo" type="button" class="btn btn-warning btn-sm" @click="downloadPDF(form)"><span class="fa fa-download"></span> &nbsp; {{ form.nombreArchivo }}</button>&nbsp;
                  <button v-if="form.nombreArchivo" type="button" class="btn btn-danger btn-sm" @click="eliminarArchivo(form.id)"><span class="fa fa-trash"></span>&nbsp;Eliminar</button>
                </div>
              </template>
            </li>
          </ul>
        </div>
        <h3 style="text-align: left;">Administrador</h3>
        <div class="row">
          <ul class="styled-list col-md-12">
            <li class="list-item row" v-for="form in arregloAdministrador" :key="form.id">
              <template v-if="form.tipo == 'Administrador'">
                <div class="col-md-4" style="text-align: left;">
                  <span v-if="form.estatus == 'Pendiente'" class="circle"></span>
                  <span v-else class="circlecolor"></span>
                  {{ form.nombre }}
                </div>
                <div class="col-md-8" style="text-align: left;">
                  <input type="file" class="form-control" @change="event => handleFileUpload(event, form.id)" /><br>
                  <button v-if="form.nombreArchivo" type="button" class="btn btn-warning btn-sm" @click="downloadPDF(form)"><span class="fa fa-download"></span> &nbsp; {{ form.nombreArchivo }}</button>&nbsp;
                  <button v-if="form.nombreArchivo" type="button" class="btn btn-danger btn-sm" @click="eliminarArchivo(form.id)"><span class="fa fa-trash"></span>&nbsp;Eliminar</button>
                </div>
              </template>
            </li>
          </ul>
        </div>
        <button type="button" class="btn" style="background-color: #F49315; color: white;" @click="submitFiles">Guardar archivos</button>
      </div>
    </div>
    <br>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { ref, onMounted } from 'vue';

export default {
  setup() {
    const isLoading = ref(false);
    const files = ref({});
    const arregloLegal = ref([]);
    const arregloInspector = ref([]);
    const arregloCRE = ref([]);
    const arregloAdministrador = ref([]);
    const rutaServer = ref('https://backsarei.seguridadeninspeccion.com/api/');
    const rutaImagenes = ref('https://backsarei.seguridadeninspeccion.com/');
    //const rutaServer = ref('http://127.0.0.1:8000/api/');
    //const rutaImagenes = ref('http://127.0.0.1:8000/');


    const handleFileUpload = (event, formId) => {
      const file = event.target.files[0];
      files.value[formId] = file;
    };

    const submitFiles = async () => {
      const formData = new FormData();

      const idcotizacion = localStorage.getItem('idcotizacion');

      formData.append('idcotizacion', idcotizacion);

      for (const [key, value] of Object.entries(files.value)) {
        formData.append(key, value);
      }
     
      try {
        const token = localStorage.getItem('accessToken');
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        };

        const response = await axios.post('https://backsarei.seguridadeninspeccion.com/api/guardarArchivosInspeccion', formData, config);
        //const response = await axios.post('http://127.0.0.1:8000/api/guardarArchivosInspeccion', formData, config);
        
        if (response.status == 200) {
          Swal.fire('¡Éxito!', 'Archivos importados', 'success');
          await consultarFormulario();
        }
      } catch (error) {
        Swal.fire('Error!', 'Capacidad de archivo no permitido', 'error');

        console.error('Error enviando archivos:', error);
      }
    };

    const consultarFormulario = async () => {
      isLoading.value = true;
      const id = localStorage.getItem('idcotizacion');
      try {
        const response = await axios.post(`${rutaServer.value}cosultarDocumentos`, { idcotizacion: id });
        console.log(response);
        if (response.status === 200 && Array.isArray(response.data)) {
          arregloLegal.value = [];
          arregloInspector.value = [];
          arregloCRE.value = [];
          arregloAdministrador.value = [];
          response.data.forEach(ele => {
            let ruta = '';
            let nombreArchivo = '';
            if (ele.url_pdf && ele.url_pdf.trim() !== '') {
              ruta = `${rutaImagenes.value}${ele.url_pdf}`;
              const result = ele.url_pdf.split("/");
              nombreArchivo = result[2];
            }
            const objeto = {
              nombre: ele.nombre,
              estatus: ele.estatus,
              tipo: ele.tipo,
              id: ele.id,
              url_pdf: ruta,
              nombreArchivo: nombreArchivo,
              url: ele.url_pdf
            };
            switch (ele.tipo) {
              case 'Legal':
                arregloLegal.value.push(objeto);
                break;
              case 'Inspector':
                arregloInspector.value.push(objeto);
                break;
              case 'CRE':
                arregloCRE.value.push(objeto);
                break;
              case 'Administrador':
                arregloAdministrador.value.push(objeto);
                break;
              default:
                break;
            }
          });
        }
      } catch (error) {
        console.error('Error consultando documentos:', error);
      } finally {
        isLoading.value = false;
      }
    };

    const downloadPDF  = async (ruta) => {
          // URL del archivo PDF en el servidor
          const pdfUrl = ruta.url_pdf;
          // Abrir el PDF en una nueva pestaña
          window.open(pdfUrl, '_blank');
        };
       

    const eliminarArchivo = async (formId) => {
      try {
        const token = localStorage.getItem('accessToken');
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        };

        const response = await axios.post('https://backsarei.seguridadeninspeccion.com/api/actualizarArchivosInspeccion', { id: formId }, config);
        //const response = await axios.post('http://127.0.0.1:8000/api/actualizarArchivosInspeccion', { id: formId }, config);
        
        if (response.status == 200) {
          Swal.fire('¡Éxito!', 'Archivo eliminado', 'success');
          await consultarFormulario();
        }
      } catch (error) {
        console.error('Error eliminando el archivo:', error);
      }
    };

    onMounted(() => {
      consultarFormulario();
    });

    return {
      isLoading,
      files,
      arregloLegal,
      arregloInspector,
      arregloCRE,
      arregloAdministrador,
      handleFileUpload,
      submitFiles,
      downloadPDF,
      eliminarArchivo,
    };
  }
};
</script>

<style>
.circle {
  height: 15px;
  width: 15px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
}

.circlecolor {
  height: 15px;
  width: 15px;
  background-color: green;
  border-radius: 50%;
  display: inline-block;
}

.styled-list {
  list-style-type: none;
}

.list-item {
  margin-bottom: 10px;
}
</style>
